import { Components, Theme } from '@mui/material';
import { badgeClasses } from '../badge';
import {
  Brand1,
  Brand4,
  Brand5,
  Content,
  Flamingo,
  Surface,
  Turquoise,
  White,
} from '../color';
import { label1 } from '../typography/jscss';
import { avatarClasses, getAvatarSizeStyle, getAvatarSizeCssMixin } from './constants';

export const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  defaultProps: {
    variant: 'circular',
  },
  styleOverrides: {
    root: {
      boxSizing: 'border-box',
      backgroundColor: Surface.dark,
      color: Content.main,
      ...label1,
      ...getAvatarSizeStyle('xl'),
      ...getAvatarSizeStyle('lg'),
      ...getAvatarSizeStyle('md'),
      ...getAvatarSizeStyle('sm'),
      ...getAvatarSizeStyle('xs'),
      [`.${badgeClasses.badge} &`]: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: White,
      },
      [`.${badgeClasses.xl} > &`]: {
        ...getAvatarSizeCssMixin('xl'),
      },
      [`.${badgeClasses.lg} > &`]: {
        ...getAvatarSizeCssMixin('lg'),
      },
      [`.${badgeClasses.md} > &`]: {
        ...getAvatarSizeCssMixin('md'),
      },
      [`.${badgeClasses.sm} > &`]: {
        ...getAvatarSizeCssMixin('sm'),
      },
      [`.${badgeClasses.xs} > &`]: {
        ...getAvatarSizeCssMixin('xs'),
      },
      [`&.${avatarClasses.dark}`]: {
        backgroundColor: Surface.inverse,
        color: Content.inverse,
      },
      [`&.${avatarClasses.brand1}`]: {
        backgroundColor: Brand1.main,
        color: Brand1.text,
      },
      [`&.${avatarClasses.brand4}`]: {
        backgroundColor: Brand4.main,
        color: Brand4.text,
      },
      [`&.${avatarClasses.flamingo}`]: {
        backgroundColor: Flamingo[60],
        color: Brand5.text,
      },
      [`&.${avatarClasses.turquoiseLight}`]: {
        backgroundColor: Surface.dark,
        color: Content.main,
      },
      [`&.${avatarClasses.turquoiseDark}`]: {
        backgroundColor: Turquoise[90],
        color: Brand5.text,
      },
    },
    rounded: {
      borderRadius: 8,
      [`&.${avatarClasses.xs}`]: {
        borderRadius: 2,
      },
    },
    img: {
      objectFit: 'contain',
    },
  },
};
